import IndicadorDashboardItem from "model/indicadores/IndicadorDashboardItem";
import { useEffect, useState } from "react";
import IndicadorService from "service/indicadores/IndicadorService";
import { VictoryAxis, VictoryChart, VictoryLine, VictoryScatter, VictoryTheme, VictoryTooltip, VictoryVoronoiContainer } from "victory";
import { formatarDataColeta } from "../IndicadorUtil";

type Props = {
    dados: IndicadorDashboardItem[];
    unidadeMedida?: string | null;
}

const indicadorService = new IndicadorService();
export default function IndicadorChartLine(props: Props) {
    const [ticks, setTicks] = useState<number[]>([]);

    useEffect(() => {
        const maiorColeta = Math.max(...props.dados.map((dado: IndicadorDashboardItem) => (dado?.coleta?.valorColeta || 0)).filter((valor): valor is number => valor !== null));
        const menorColeta = Math.min(...props.dados.map((dado: IndicadorDashboardItem) => (dado?.coleta?.valorColeta || 0)).filter((valor): valor is number => valor !== null));
        const maiorMeta = Math.max(...props.dados.map((dado: IndicadorDashboardItem) => (dado.meta?.meta || 0)).filter((valor): valor is number => valor !== null));
        const menorMeta = Math.min(...props.dados.map((dado: IndicadorDashboardItem) => (dado.meta?.meta || 0)).filter((valor): valor is number => valor !== null));
        const maior = Math.max(maiorColeta, maiorMeta);
        const menor = Math.min(menorColeta, menorMeta);
        const step = Math.ceil((maior - menor) / 4); // ajustável: define a "densidade" dos ticks

        for (let v = menor; v <= maior; v += step) {
            ticks.push(v);
        }

        // Garante que menor e maior estejam incluídos (caso o loop falhe)
        if (!ticks.includes(menor)) ticks.unshift(menor);
        if (!ticks.includes(maior)) ticks.push(maior)

        setTicks([...ticks]);
    }, [])



    return (
        <div style={{ width: "100%", height: "85vh" }}>
            <VictoryChart
                theme={VictoryTheme.material}
                padding={{ top: 20, bottom: 100, left: 0, right: 0 }}
                height={window.innerHeight - 200}
                width={window.innerWidth - 700}
                containerComponent={
                    <VictoryVoronoiContainer
                        voronoiDimension="x"
                    />
                }

            >
                <VictoryAxis
                    tickValues={props.dados.map((dado: IndicadorDashboardItem) => formatarDataColeta(dado.coleta))}
                    tickFormat={props.dados.map((dado: IndicadorDashboardItem) => formatarDataColeta(dado.coleta))}
                    style={{
                        tickLabels: { fontSize: 10 },
                        grid: { stroke: '#CCCCCC' }
                    }}

                />
                <VictoryAxis
                    dependentAxis
                    tickValues={ticks}
                    tickFormat={(x) => {
                        if (typeof x == "number") return (`${x.toFixed(2).replace(".", ",")}`)
                        return "0";
                    }}
                    style={{
                        tickLabels: { fontSize: 10 },
                        grid: { stroke: '#CCCCCC' }
                    }}
                />

                <VictoryLine
                    data={props.dados.map((dado: IndicadorDashboardItem) => ({
                        x: formatarDataColeta(dado.coleta),
                        y: dado.meta?.meta || 0
                    }))}
                    theme={VictoryTheme.material}
                    y={(datum) => datum.y}
                    style={{ data: { stroke: "#555" } }}
                    interpolation={"linear"}
                    labels={({ datum }: { datum: any }) => {
                        const simbolo = indicadorService.getTipoMeta(props.dados[datum._x - 1].meta?.tipo || "").simbolo;
                        return "Meta:" + simbolo + " " + datum.y
                    }}
                    labelComponent={<VictoryTooltip
                        cornerRadius={10}
                        pointerWidth={30}
                        pointerLength={20}
                        flyoutPadding={{ top: 10, bottom: 10, left: 25, right: 25 }}
                        style={{ fontSize: "16px", fill: "#FFF" }}
                        flyoutStyle={{ fill: "#414B5F" }}
                        orientation="right"
                    />}
                />
                <VictoryScatter
                    data={props.dados.map((dado: IndicadorDashboardItem) => ({
                        x: formatarDataColeta(dado.coleta),
                        y: dado.meta?.meta || 0
                    }))}
                    style={{ data: { fill: "#555" } }}
                    y={(datum) => datum.y}

                />
                <VictoryLine
                    data={props.dados.map((dado: IndicadorDashboardItem) => ({
                        x: formatarDataColeta(dado.coleta),
                        y: dado?.coleta?.valorColeta || 0
                    }))}
                    theme={VictoryTheme.material}
                    y={(datum) => datum.y}
                    style={{ data: { stroke: "#0E9CFF" } }}
                    interpolation={"linear"}
                    labels={({ datum }: { datum: any }) => "Coletado: " + indicadorService.getValorConvertido(props.unidadeMedida||"", datum.y)}
                    labelComponent={<VictoryTooltip
                        cornerRadius={10}
                        pointerWidth={30}
                        pointerLength={20}
                        flyoutPadding={{ top: 10, bottom: 10, left: 25, right: 25 }}
                        style={{ fontSize: "16px", fill: "#FFF" }}
                        flyoutStyle={{ fill: "#414B5F" }}
                        orientation="right"
                    />}
                />
                <VictoryScatter
                    data={props.dados.map((dado: IndicadorDashboardItem) => ({
                        x: formatarDataColeta(dado.coleta),
                        y: dado?.coleta?.valorColeta || 0
                    }))}
                    style={{ data: { fill: "#0E9CFF" } }}
                    y={(datum) => datum.y}

                />
            </VictoryChart>
        </div>
    );
}